import { ILayout } from '../../types/layout';
import { IRootState } from '../../types/redux/root';

export const layoutStateSelector = (layoutId: string) => (root: IRootState): ILayout => root.layouts[layoutId] || {};
